import { render } from "./Adminreviews.vue?vue&type=template&id=94ef53a4&scoped=true"
import script from "./Adminreviews.vue?vue&type=script&lang=js"
export * from "./Adminreviews.vue?vue&type=script&lang=js"

import "./Adminreviews.vue?vue&type=style&index=0&id=94ef53a4&lang=css"
import "./Adminreviews.vue?vue&type=style&index=1&id=94ef53a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ef53a4"]])

export default __exports__